export default "__VITE_ASSET__07l_y8hU__"